import makeApiRequest, { DownloadOption } from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';
import { SEARCH_OPERATORS_PRIMITIVE } from 'src/constants/SearchOperators';
import { TicketModel } from 'src/models/TicketModel';

export const getEventTicketsData =
  (organisation: string, eventId: number, productId: number) => makeApiRequest({
    method: 'POST',
    url: `${API_URL.eventTickets}?debug=1`,
    organisation,
    data: {
      fields: ['event_tickets.ticket_identifier'],
      filters: {
        and: [
          ['event_tickets.event_id', SEARCH_OPERATORS_PRIMITIVE.eq, eventId],
          ['event_tickets.product_id', SEARCH_OPERATORS_PRIMITIVE.eq, productId],
          ['event_tickets.status', SEARCH_OPERATORS_PRIMITIVE.ne, 'available'],
          ['event_tickets.deleted_at', SEARCH_OPERATORS_PRIMITIVE.null],
        ],
      },
    },
  });

// Cleared form fields arrive as '', but the API expects null for every optional ticket field.
const emptyToNull = (value: string | number | null | undefined) => (
  value === '' || value === undefined || value === null ? null : value
);

export const getTicketData =
  (organisation: string, ticketId: number) => makeApiRequest({
    method: 'GET',
    url: `${API_URL.eventTicket}/${ticketId}`,
    organisation,
  });

export const deleteTicketData =
  (organisation: string, id: number) => makeApiRequest({
    method: 'DELETE',
    url: `${API_URL.eventTicket}/${id}`,
    organisation,
  });

export const putTicketData =
  (organisation: string, ticket: TicketModel) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.eventTicket}/${ticket.id}`,
    organisation,
    data: {
      event_id: ticket.event_id,
      product_id: ticket.product_id,
      contact_id: ticket.contact_id,
      status: ticket.status,
      seller_id: emptyToNull(ticket.seller_id),
      invoice_id: emptyToNull(ticket.invoice_id),
      sold_price: emptyToNull(ticket.sold_price),
      first_name: emptyToNull(ticket.first_name),
      last_name: emptyToNull(ticket.last_name),
      email: emptyToNull(ticket.email),
      phone: emptyToNull(ticket.phone),
      ticket_identifier: emptyToNull(ticket.ticket_identifier),
    },
  });

export const postTicketData =
  (organisation: string, ticket: TicketModel) => makeApiRequest({
    method: 'POST',
    url: API_URL.eventTicket,
    organisation,
    data: {
      event_id: ticket.event_id,
      product_id: ticket.product_id,
      contact_id: ticket.contact_id,
      status: ticket.status,
      seller_id: emptyToNull(ticket.seller_id),
      sold_price: emptyToNull(ticket.sold_price),
      first_name: emptyToNull(ticket.first_name),
      last_name: emptyToNull(ticket.last_name),
      email: emptyToNull(ticket.email),
      phone: emptyToNull(ticket.phone),
      ticket_identifier: emptyToNull(ticket.ticket_identifier),
    },
  });

export interface SendTicketsPayload {
  channel: 'email' | 'sms',
  ticket_ids?: number[],
  event_id?: number,
  message?: string,
}

export const sendTicketsData =
  (organisation: string, payload: SendTicketsPayload) => makeApiRequest({
    method: 'POST',
    url: API_URL.eventTicketsSend,
    organisation,
    data: payload,
  });

export interface DownloadTicketsPayload {
  ticket_ids?: number[],
  event_id?: number,
}

export const downloadTicketsData =
  (organisation: string, payload: DownloadTicketsPayload, filename: string) => makeApiRequest(
    {
      method: 'POST',
      url: API_URL.eventTicketsDownload,
      organisation,
      data: payload,
    },
    DownloadOption.download,
    filename,
  );
